/**
 * Internal dependencies
 */
import { JobPosting } from '../types';

import LocationIcon from '../../../../assets/svg/icon/map-pin-2.svg';
import TimeIcon from '../../../../assets/svg/icon/time.svg';

interface JobCardProps {
	job: JobPosting;
}

export default function JobCard( { job }: JobCardProps ) {
	/**
	 * Strip HTML tags and decode entities for plain text display
	 */
	const stripHtml = ( html: string ): string => {
		// Create a temporary div to parse HTML
		const temp = document.createElement( 'div' );
		temp.innerHTML = html;
		// Get text content (strips all HTML)
		return temp.textContent || temp.innerText || '';
	};

	const truncateDescription = ( text: string, maxLength: number = 500 ): string => {
		// Strip HTML first, then truncate
		const plainText = stripHtml( text );
		if ( plainText.length <= maxLength ) {
			return plainText;
		}
		return plainText.slice( 0, maxLength ).trim() + '...';
	};

	return (
		<article className="job-card">
			<h3 className="job-card__title">
				<a href={ job.applyUrl } className="job-card__link" target="_blank" rel="noopener noreferrer">
					{ job.title }
				</a>
			</h3>

			<div className="job-card__description">
				<p>{ truncateDescription( job.description ) }</p>
			</div>

			<div className="job-card__meta">
				{ job.location && (
					<span className="job-card__location">
						<LocationIcon className="job-card__icon" />
						{ job.location }
					</span>
				) }

				{ job.employmentType && (
					<span className="job-card__contract-type">
						<TimeIcon className="job-card__icon" />
						{ job.employmentType }
					</span>
				) }
			</div>
		</article>
	);
}
